import { render, staticRenderFns } from "./NotFoundPanel.vue?vue&type=template&id=be0080cc&scoped=true&"
import script from "./NotFoundPanel.vue?vue&type=script&lang=js&"
export * from "./NotFoundPanel.vue?vue&type=script&lang=js&"
import style0 from "./NotFoundPanel.vue?vue&type=style&index=0&id=be0080cc&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be0080cc",
  null
  
)

export default component.exports